import React from "react";
import { Badge } from "@mui/joy";
import type { BadgeProps } from "@mui/joy";
import type { SxProps } from "@mui/joy/styles/types";
import IconButtonCTA from "../../common/IconButtonCTA";
import ActionTooltip from "../../common/ActionTooltip";
import {
  ctaSuccessLightEnabledSx,
  listRowAccentPlainSx,
  listRowDangerPlainSx,
  trainingRowBadgeSx,
} from "../../../styles/globalStyles";

type Props = {
  title: string;
  ariaLabel: string;
  icon: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  ctaVariant: "accent" | "danger" | "success";
  badgeContent?: number | string;
  badgeColor?: BadgeProps["color"];
  sx?: SxProps;
};

export default function TrainingRowTooltipButton({
  title,
  ariaLabel,
  icon,
  onClick,
  disabled,
  ctaVariant,
  badgeContent,
  badgeColor = "neutral",
  sx: extraSx,
}: Props) {
  const plainSx: SxProps =
    ctaVariant === "danger"
      ? listRowDangerPlainSx
      : ctaVariant === "accent"
        ? listRowAccentPlainSx
        : ctaSuccessLightEnabledSx;

  const button = (
    <IconButtonCTA
      ctaVariant={ctaVariant}
      aria-label={ariaLabel}
      size="sm"
      variant="plain"
      disabled={disabled}
      onClick={onClick}
      sx={extraSx ? ([plainSx, extraSx] as SxProps) : plainSx}
    >
      {icon}
    </IconButtonCTA>
  );

  const withBadge =
    badgeContent !== undefined ? (
      <Badge badgeContent={badgeContent} size="sm" color={badgeColor} sx={trainingRowBadgeSx}>
        {button}
      </Badge>
    ) : (
      button
    );

  return (
    <ActionTooltip title={title} disabled={disabled}>
      {withBadge}
    </ActionTooltip>
  );
}
